<template>
  <v-container
    fill-height
    fluid
    grid-list-xl
  >
    <v-layout
      justify-center
      wrap
    >
      <v-flex
        md12
      >
        <div>
          <material-card
            :color="color"
            title="Products"
            text="A table of Products"
          >
            <v-layout>
              <v-flex
                xs12
                sm12
                md12>
                <v-text-field
                  v-model="barcode"
                  :loading="loading"
                  autofocus
                  append-icon="search"
                  label="Search"
                  hide-details
                  @keyup.enter.native="searchBarcode"/>
              </v-flex>
            </v-layout>
            <v-spacer/>

            <v-dialog
              v-model="dialog"
              persistent
              max-width="768px">
              <template v-slot:activator="{ on }">
                <v-layout>
                  <v-flex
                    xs12
                    sm3
                    md3>
                    <v-btn
                      :color="color"
                      dark
                      class="mb-2"
                      v-on="on">
                      New Product
                    </v-btn>
                  </v-flex>
                  <v-flex
                    xs12
                    sm3
                    md3
                  >
                    <v-select
                      v-model="store"
                      :items="StoreList"
                      item-text="name"
                      item-value="id"
                      label="Store"
                      placeholder="All Stores"
                      dense
                    />
                  </v-flex>
                  <v-flex
                    xs12
                    sm6
                    md6>
                    <v-text-field
                      v-model="search"
                      :loading="loading"
                      append-icon="search"
                      label="Search"
                      hide-details/>
                  </v-flex>
                </v-layout>
              </template>
              <v-card>
                <v-card-text>
                  <v-container grid-list-md >
                    <v-layout wrap>
                      <v-flex
                        xs12
                        sm6
                        md6>
                        <v-text-field
                          :rules="[rules.required]"
                          v-model="editedItem.aisle"
                          :label="aisleName" />
                      </v-flex>
                      <v-flex
                        xs12
                        sm6
                        md6>
                        <v-text-field
                          :rules="[rules.required]"
                          v-model="editedItem.section"
                          :label="sectionName" />
                      </v-flex>

                      <v-flex
                        xs12
                        sm6
                        md6>
                        <v-text-field
                          :rules="[rules.required]"
                          v-model="editedItem.name"
                          label="Product Name" />
                      </v-flex>

                      <v-flex
                        xs12
                        sm6
                        md6>

                        <v-select
                          v-model="editedItem.store_id"
                          :items="StoreList.filter(c=>c.active == true)"
                          item-text="name"
                          item-value="id"
                          label="Store"
                          dense
                        />
                      </v-flex>

                      <v-flex
                        xs12
                        sm12
                        md12>
                        <v-textarea
                          v-model="editedItem.description"
                          label="Description" />
                      </v-flex>
                    </v-layout>
                  </v-container>
                </v-card-text>

                <v-card-actions>
                  <v-spacer />
                  <v-checkbox
                    v-model="editedItem.active"
                    class="float-right"
                    label="Active"/>
                  <v-spacer/>
                  <v-btn
                    color="blue darken-1"
                    flat
                    @click="close">Cancel</v-btn>
                  <v-btn
                    color="blue darken-1"
                    flat
                    @click="save">Save</v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>

            <v-data-table
              :headers="headers"
              :items="FilteredProductList"
              :disable-initial-sort="true"
              :rows-per-page-items ="rowsAmount"
              :search="search"
              class="elevation-1"
            >

              <!-- change table header background and text color(or other properties) -->
              <template
                slot="headerCell"
                slot-scope="{ header }"
              >
                <span
                  class="subheading font-weight-light text-general text--darken-3"
                  v-text="header.text"
                />
              </template>
              <template v-slot:items="props">
                <tr @click="editItem(props.item)">

                  <td>{{ props.item.id }}</td>
                  <td>
                    {{ props.item.name }}
                  </td>

                  <td>{{ props.item.aisle }}</td>
                  <td>{{ props.item.section }}</td>
                  <td>{{ props.item.store.name }}</td>
                  <td> <v-icon v-if="props.item.active">check</v-icon></td>
                  <td class="justify-center ">
                    <v-icon
                      small
                      class="mr-2"
                      @click="editItem(props.item)">edit</v-icon>
                    <v-icon
                      small
                      @click="deleteItem(props.item)">delete</v-icon>
                  </td>
                </tr>
              </template>
            </v-data-table>
            <v-snackbar
              v-model="snack"
              :timeout="5000"
              :color="snackColor">
              {{ snackText }}
              <v-btn
                flat
                @click="snack = false">Close</v-btn>
            </v-snackbar>
          </material-card>
        </div>
      </v-flex>

    </v-layout>
  </v-container>
</template>

<script>
  import axios from 'axios'
  import { mapState } from 'vuex'

  export default {
  data: () => ({
    snack: false,
    snackColor: '',
    snackText: '',
    rules: {
      required: value => !!value || 'Required.',
      max256chars: v => v.length <= 256 || 'Input too long!'
    },
    pagination: {},
    aisleName: 'Aisle',
    sectionName: 'Section',
    lastAisle: '',
    lastSection: '',
    ProductList: [

    ],
    StoreList: [

    ],
    store: 'all',
    loading: true,

    startCalendar: false,
    endCalendar: false,

    checkboxAdmin: true,
    checkboxActive: true,
    rowsAmount: [10, 20, 50, { 'text': '$vuetify.dataIterator.rowsPerPageAll', 'value': -1 }],
    dialog: false,
    search: '',
    headers: [
      {
        text: 'Id',
        align: 'left',
        value: 'id'
      },
      {
        text: 'Name',
        align: 'left',
        value: 'name'
      },
      {
        text: 'Aisle',
        align: 'left',
        value: 'aisle'
      },
      {
        text: 'Section',
        align: 'left',
        value: 'section'
      },
      {
        text: 'Store',
        align: 'left',
        value: 'store.name'
      },
      {
        text: 'Active',
        align: 'left',
        value: 'active'
      },
      {
        text: 'Actions',
        align: 'left',
        value: 'actions',
        sortable: false
      }
    ],
    editedIndex: -1,
    editedItem: {
      id: '',
      name: '',
      description: '',
      aisle: '',
      section: '',
      store_id: null,
      store: {
        name: '',
        description: ''
      },
      active: true
    },
    defaultItem: {
      id: '',
      name: '',
      description: '',
      aisle: '',
      section: '',
      store_id: null,
      store: {
        name: '',
        description: ''
      },
      active: true
    },
    barcode: ''
  }),

  computed: {
    ...mapState('app', ['color']),
    formTitle () {
      return this.editedIndex === -1 ? 'New Product' : 'Edit Product'
    },
    FilteredProductList () {
      if (this.store == 'all') {
        return this.ProductList
      }
      let self = this
      return this.ProductList.filter(function (s) {
        return s.store_id == self.store
      })
    }
  },

  watch: {
    dialog (val) {
      if (val && this.store !== 'all' && this.editedItem.id !== '') {
        this.editedItem.store_id = this.store
        this.editedItem.store.id = this.store
        this.getCustomName()
      }
      val || this.close()
    }
  },
  // called when page is created before dom
  created () {
    this.index()
    this.getStores()
    // this.$store.dispatch('autoRefreshToken')
    // .then(response => console.log(response))
    // .catch(error => console.log(error))
  },

  methods: {
    searchBarcode () {
      axios.post('/api/barcodes', { code: this.barcode})
          .then((response) => {
            this.editedItem.name = response.data.name
            this.editedItem.description = response.data.description
            this.dialog = true
            this.saveInline()
            this.$store.state.spinning = false
          })
          .catch(error => {
            if (error.response.status == '422') {
              this.showError(error.response.data.errors)
            }
            console.log(error)
            this.cancelInline
            this.$store.state.spinning = false
          })
  },
    index () {
      this.loading = true
      let self = this
      axios.get('/api/products')
              .then(response => {
                self.ProductList = response.data
                self.loading = false
              })
              .catch(err => {
                if (err.response.status == '403') {
                  this.showError('Unauthorized')
                } else {
                  this.showError(err.response.data.errors)
                }
                self.loading = false
                console.log(err.response.data.errors)
              })
    },

    getCustomName () {
      for (var i = 0; i < this.StoreList.length; i++) {
        if (this.StoreList[i].id == this.store) {
          this.aisleName = this.StoreList[i].aisle_name
          this.sectionName = this.StoreList[i].section_name
        }
      }
    },
    getStores () {
      axios.get('/api/stores')
              .then(response => {
                this.StoreList = response.data
                this.StoreList.push({
                  id: null,
                  name: 'Unassigned',
                  description: 'Products that are not assigned stores',
                  active: true
                })
              })
              .catch(err => {
                if (err.response.status == '403') {
                  this.showError('Unauthorized')
                } else {
                  this.showError(err.response.data.errors)
                }
              })
    },
    // object.assign fills in the empty object with the properties of item
    editItem (item, dbox = true) {
      this.editedIndex = this.ProductList.indexOf(item)
      this.editedItem = Object.assign({}, item)
      this.dialog = dbox
    },

    callTableAction (item, endpoint, method) {
      let tableItem = this.editedItem
      this.$store.dispatch('updateTableItem', { endpoint, tableItem, method })
        .then((response) => this.saveInline())
        .catch(error => {
          console.log(error)
          this.cancelInline
        })
    },

    deleteItem (item) {
      const index = this.ProductList.indexOf(item)
      if (confirm('Are you sure you want to delete this item?')) {
        this.$store.state.spinning = true
        axios.delete('/api/products/' + item.id)
                .then((response) => {
                  this.ProductList.splice(index, 1)
                  this.deleteInline()
                          this.close()
                          this.$store.state.spinning = false
                        }
                )
                .catch(error => {
                  if (error.response.status == '403') {
                    this.showError('Unauthorized')
                  } else {
                    this.showError(error.response.data.errors)
                  }
                  console.log(error)
                  this.cancelInline
                  this.$store.state.spinning = false
                })
      }
    },

    close () {
      this.dialog = false
      this.barcode = ''
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem)
        this.editedIndex = -1
        this.editedItem.aisle = this.lastAisle
        this.editedItem.section = this.lastSection
      }, 300)
    },

    save () {
      // update
      if (this.editedItem.id !== '') {
        this.editedItem.store_id = this.editedItem.store.id ? this.editedItem.store.id : this.store
        this.$store.state.spinning = true
        axios.put('/api/products/' + this.editedItem.id, this.editedItem)
          .then((response) => {
            Object.assign(this.ProductList[this.editedIndex], response.data)
                this.saveInline()
              this.close()
                    this.$store.state.spinning = false
                  }
          )
          .catch(error => {
            if (error.response.status == '422') {
              this.showError(error.response.data.errors)
            }
            console.log(error)
            this.cancelInline
            this.$store.state.spinning = false
          })
      }
      // create
      else {
        this.$store.state.spinning = true
        axios.post('/api/products', this.editedItem)
                .then((response) => {
                  this.lastAisle = this.editedItem.aisle
                  this.lastSection = this.editedItem.section
                  this.ProductList.unshift(response.data)
                  this.saveInline()
                  this.index()
                  this.close()
                  this.$store.state.spinning = false
                })
          .catch(error => {
            if (error.response.status == '422') {
              this.showError(error.response.data.errors)
            }
            console.log(error)
            this.cancelInline
            this.$store.state.spinning = false
          })
      }
    },
    // toasts/snackbar messages for actions
    saveInline () {
      this.snack = true
      this.snackColor = 'success'
      this.snackText = 'Product saved'
    },
    deleteInline () {
      this.snack = true
      this.snackColor = 'success'
      this.snackText = 'Product deleted'
    },
    showError (errorMessage) {
      this.snack = true
      this.snackColor = 'error'
      this.snackText = errorMessage || 'Something went wrong, try again later!'
    },
    cancelInline () {
      this.snack = true
      this.snackColor = 'error'
      this.snackText = 'Canceled'
    },
    reset () {
      this.snack = true
      this.snackColor = 'success'
      this.snackText = 'Data reset to default'
    },
    openInline () {
      this.snack = true
      this.snackColor = 'info'
      this.snackText = 'Dialog opened'
    },
    closeInline () {
      console.log('Dialog closed')
    }
  }
}
</script>

<style>
table.v-table thead tr {
  color: red !important;
}
tbody tr:nth-of-type(odd) {
  background-color: rgba(0, 0, 0, .05);
}
</style>
